import React, { useState } from "react";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";

type CredentialDateFieldsProps = {
  defaultIssuedOn?: string;
  defaultExpiresOn?: string;
  layout?: "stack" | "grid";
};

export function CredentialDateFields({
  defaultIssuedOn = "",
  defaultExpiresOn = "",
  layout = "stack",
}: CredentialDateFieldsProps) {
  const [issuedOn, setIssuedOn] = useState(defaultIssuedOn);
  const fields = (
    <>
      <div>
        <FieldLabel htmlFor="credential_issued_on">Issued</FieldLabel>
        <TextInput
          id="credential_issued_on"
          name="credential[issued_on]"
          type="date"
          defaultValue={defaultIssuedOn}
          onChange={(event) => setIssuedOn(event.target.value)}
        />
      </div>
      <div>
        <FieldLabel htmlFor="credential_expires_on">Expires</FieldLabel>
        <TextInput
          id="credential_expires_on"
          name="credential[expires_on]"
          type="date"
          defaultValue={defaultExpiresOn}
          min={issuedOn || undefined}
        />
      </div>
    </>
  );

  if (layout === "grid") {
    return <div className="grid gap-4 sm:grid-cols-2">{fields}</div>;
  }

  return fields;
}
